/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Ordered_ListInputs */



/**
* | output |
* | --- |
* | "Numbered list" |
*
* @param {Rte_Ordered_ListInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_ordered_list = /** @type {((inputs?: Rte_Ordered_ListInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Ordered_ListInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Genummerde lijst")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste numérotée")
	return /** @type {LocalizedString} */ ("Numbered list")
});